import { useEffect, useState, useCallback } from "react";
import { fetchDoctors, fetchMetadata } from "./api";

const EMPTY_META = { specialties: [], cities: [], statuses: [] };

export const useMetadata = () => {
  const [meta, setMeta] = useState(EMPTY_META);
  useEffect(() => {
    let cancelled = false;
    fetchMetadata()
      .then((m) => { if (!cancelled) setMeta(m); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return meta;
};

export const useDoctorList = (params) => {
  const [loading, setLoading] = useState(true);
  const [doctors, setDoctors] = useState([]);
  const [total, setTotal] = useState(0);

  const limit = Number(params.limit || 12);
  const skip = Number(params.skip || 0);

  const key = JSON.stringify({
    ...params,
    limit,
    skip,
  });

  const reload = useCallback(() => {
    setLoading(true);

    fetchDoctors({
      ...params,
      limit,
      skip,
    })
      .then((d) => {
        setDoctors(d.doctors || []);
        setTotal(d.total || 0);
      })
      .catch((err) => {
        console.error("Doctor fetch failed:", err);
        setDoctors([]);
        setTotal(0);
      })
      .finally(() => setLoading(false));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    loading,
    doctors,
    total,
    reload,
    limit,
    skip,
    hasMore: skip + doctors.length < total,
  };
};
